var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#001321"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3812 35.4106L16 40.8559L18.1461 43.0019L19.5234 42.9699L38.9981 62.5087V63.918L41.0801 66L56.2626 50.8815L46.4292 40.984L40.952 46.4613L45.3081 50.8174L41.016 55.1096L21.3812 35.4106Z",
    fill: "#00E3B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6188 46.5894L66 41.1441L63.8539 38.9981L62.4766 39.0301L43.0019 19.4914V18.082L40.9199 16L25.7373 31.1185L35.5707 41.016L41.048 35.5388L36.6918 31.1826L40.9839 26.8905L60.6188 46.5894Z",
    fill: "#00E3B4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogoDark);
export default __webpack_public_path__ + "static/media/profile-logo-dark.cbb5112f655372d45aaa2336610986f2.svg";
export { ForwardRef as ReactComponent };